export function dismissAuthModal(ctx) {
    return ctx.dispatch('DISMISS_AUTH_MODAL');
}

export function showAuthModal(ctx) {
    return ctx.dispatch('SHOW_AUTH_MODAL');
}



// WEBPACK FOOTER //
// ./js/launch/actions/authActions.js